import * as yup from 'yup'

import {
  entityType,
  formedOn,
  legalBusinessName,
  naicsCode,
  numberOfEmployees,
  ownership,
  preferredAccountName,
  taxId,
  website,
} from '@sputnik/schema/creditApplication/businessInfo'

export const nameAndOwnershipFormValidationSchema = yup.object().shape({
  legalBusinessName: legalBusinessName.nullable(),
  preferredAccountName: preferredAccountName.nullable(),
  website,
  ownership: ownership.nullable(),
  formedOn: formedOn.nullable(),
  entityType: entityType.nullable(),
  naicsCode: naicsCode.nullable(),
  taxId: taxId.nullable(),
  numberOfEmployees: numberOfEmployees.nullable(),
})

export type NameAndOwnershipFormValidationSchema = yup.InferType<typeof nameAndOwnershipFormValidationSchema>
